// import React from "react";
// import myImage from "../../Assets/me-home.jpg";
// import whiteline from "../../Assets/zigzag-w2.png";

// const Section6 = () => {
//   return (
//     <div className="w-full bg-[#F2EFEA] relative pb-14">
//       <div className="flex flex-col lg:flex-row">
//         {/* Text Content */}
//         <div className="w-full lg:w-[45%] px-6 md:px-12 lg:px-24 py-12 lg:py-24">
//           <h1
//             className="w-[550px] ml-[450px] text-3xl md:text-4xl lg:text-[2.75rem] leading-relaxed text-left font-light text-gray-800 mb-8"
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             <span className="text-[#704735]"> Hey There,</span> <br />
//             I'm Laiba, the heart behind Connect Engage Grow.
//           </h1>

//           <p className="w-[500px] ml-[450px] text-gray-600 text-sm leading-relaxed text-left mb-16">
//             I started this journey with one goal: to help businesses like yours
//             thrive online and grow with ease. Social media can feel
//             overwhelming, but that's where I step in! From crafting unique
//             content to managing platforms and building websites, my team and I
//             make sure your brand connects with the right people and exceeds
//             expectations.
//           </p>
//           {/* Signature */}
//           <span
//             className="text-[#704735] ml-[820px] text-3xl whitespace-nowrap"
//             style={{
//               fontFamily: "theimpressionist",
//             }}
//           >
//             Laiba
//           </span>
//         </div>

//         {/* Image Section */}
//         <div className="w-full lg:w-[55%] flex items-center justify-center">
//           <img
//             src={myImage}
//             alt="Woman smiling in a hat"
//             className="w-10/12 object-cover object-center ml-48"
//           />
//         </div>

//         {/* Decorative Zigzag */}
//         <div className="absolute left-[69.3%] z-20 -mt-60">
//           <img
//             src={whiteline}
//             alt="Decorative Zigzag"
//             className="w-[450px] h-auto"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section6;
import React from "react";
import myImage from "../../Assets/me-home.jpg";
import whiteline from "../../Assets/zigzag-w2.png";

const Section6 = () => {
  return (
    <div className="w-full bg-[#F2EFEA] relative pb-14">
      <div className="flex flex-col lg:flex-row">
        {/* Text Content */}
        <div className="w-full lg:w-[45%] px-6 md:px-12 lg:px-20 py-12 lg:py-24 text-left">
          <div className="lg:w-[550px] max-w-2xl lg:ml-[250px]">
            <h1
              className="text-3xl md:text-4xl lg:text-[2.75rem] leading-relaxed mb-8"
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              <span className="text-[#704735]">Hey There,</span> <br />
              I'm Laiba, the heart behind Connect Engage Grow.
            </h1>

            <p className="text-gray-600 text-md leading-relaxed text-left mb-16 max-w-[500px]">
              I started this journey with one goal: to help businesses like
              yours thrive online and grow with ease. Social media can feel
              overwhelming, but that's where I step in! From crafting unique
              content to managing platforms and building websites, my team and I
              make sure your brand connects with the right people and exceeds
              expectations.
            </p>

            <span
              className="text-[#704735] text-3xl block text-left lg:ml-[370px] ml-[200px] sm:ml-[100px]"
              style={{
                fontFamily: "theimpressionist",
              }}
            >
              Laiba
            </span>
          </div>
        </div>

        <div className="w-full lg:w-[55%] relative">
          <img
            src={myImage}
            alt="Woman smiling in a hat"
            className="w-full lg:max-w-[650px] object-cover object-right border-2 border-t-emerald-800"
            style={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
          />
        </div>

        {/* Decorative Zigzag */}
        <img
          src={whiteline}
          alt="Decorative Zigzag"
          className="absolute w-[250px] h-auto left-[19.3%] sm:left-[19.3%] -mt-60 z-20 lg:left-[60%] lg:w-[400px]"
        />
      </div>
    </div>
  );
};

export default Section6;
